import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './PhoneInput.module.scss';
import ReactPhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

export const PhoneInput = React.forwardRef((props, ref) => {

  const {
    label = false,
    placeholder,
    help,
    className,
    error,
    required,
    classNameInputPrefixIcon,
    name,
    dropdownClass=styles.dropdown,
    ...other
  } = props;

  return (
    <div className={clsx('form-group', styles.input, className)}>
      {label && (<label> {required && <span className="required">*</span>} {label}</label>)}
      <ReactPhoneInput dropdownClass={dropdownClass} ref={ref} containerClass={clsx({"is-invalid": error})}
        placeholder={placeholder} inputProps={{name, required }} {...other} />
      {help && !error && <small className="form-text text-muted">{help}</small>}
      {error && <small className={clsx('form-text', styles.invalidFeedback)}>{error}</small>}
    </div>
  );
});

PhoneInput.defaultProps = {
  help: '',
  placeholder: '',
  className: '',
};

PhoneInput.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  help: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  className: PropTypes.string,
  classNameInputPrefixIcon: PropTypes.string,
  inputLeft: PropTypes.number,
  prefixTop: PropTypes.number,
  prefixLeft: PropTypes.number
};

export default PhoneInput;
